
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail, Gift, Check, X } from "lucide-react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
interface CouponPopupProps {
  title?: string;
  message?: string;
  onClose: () => void;
}
const CouponPopup: React.FC<CouponPopupProps> = ({
  title = "Özel İndirim Fırsatı!",
  message = "E-posta adresinizi girerek özel indirim kodunu alın.",
  onClose
}) => {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [couponCode] = useState("KAMPUS100"); // Changed from KAMPUS5 to KAMPUS100

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Lütfen geçerli bir e-posta adresi girin.");
      return;
    }
    setIsLoading(true);
    try {
      // Save email and coupon code to Supabase
      // Using type assertion to fix TypeScript error until types are regenerated
      const {
        error
      } = await (supabase.from('coupon_submissions') as any).insert([{
        email,
        coupon_code: couponCode
      }]);
      if (error) {
        console.error("Error saving submission:", error);
        throw error;
      }

      // Show success state
      setIsSubmitted(true);
      toast.success("İndirim kodunuz başarıyla gönderildi!");
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Bir hata oluştu. Lütfen tekrar deneyiniz.");
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="relative overflow-hidden bg-gradient-to-r from-indigo-500 to-purple-600 rounded-lg shadow-xl p-6 text-white">
      <button onClick={onClose} className="absolute right-3 top-3 text-white/70 hover:text-white transition-colors">
        <X className="h-5 w-5" />
      </button>
      
      {!isSubmitted ? <>
          <div className="mb-6 text-center">
            <h3 className="text-xl font-bold tracking-tight mb-2">{title}</h3>
            <p className="text-white/80">{message}</p>
          </div>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="relative">
              <Mail className="absolute left-3 top-3 h-5 w-5 text-white/50" />
              <Input type="email" placeholder="E-posta adresiniz" value={email} onChange={e => setEmail(e.target.value)} className="pl-10 bg-white/20 border-white/20 placeholder:text-white/50 text-white focus-visible:ring-white" />
            </div>
            
            <Button type="submit" disabled={isLoading} className="w-full bg-white text-indigo-600 hover:bg-white/90">
              {isLoading ? "Gönderiliyor..." : "İndirim Kodunu Al"}
            </Button>
          </form>
          
          <div className="mt-4 text-center text-sm text-white/70">
            <p>Kampüs Mentörlük ile hedeflerinize daha hızlı ulaşın!</p>
          </div>
        </> : <div className="text-center py-2">
          <div className="inline-flex justify-center items-center w-16 h-16 bg-white/20 rounded-full mb-4">
            <Check className="h-8 w-8 text-white" />
          </div>
          
          <h3 className="text-xl font-bold mb-3">İndirim Kodunuz Hazır!</h3>
          <p className="text-white/80 mb-4">Bu kodu ödeme ekranında kullanarak 100 TL indirim kazanın.</p>
          
          <div className="flex items-center justify-center gap-2 bg-white/30 p-3 rounded-lg mb-4">
            <Gift className="h-5 w-5" />
            <span className="text-xl font-mono font-bold tracking-wider">{couponCode}</span>
          </div>
          
          <Button onClick={onClose} className="bg-white text-indigo-600 hover:bg-white/90">
            Kodu Kullan
          </Button>
        </div>}
      
      <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-white/10 rounded-full"></div>
      <div className="absolute -top-12 -left-12 w-40 h-40 bg-white/10 rounded-full"></div>
    </div>;
};
export default CouponPopup;
